<template>
  <button
    role="link"
    class="h-10 w-10 bg-primary flex-c rounded-sm btn-hover"
    aria-label="Close"
    @click="backUp"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" v-bind:svg-inline="''" v-bind:class="'fill-current text-white w-4 h-4'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.999 18.908L2.909 32 0 29.09l13.085-13.085L0 2.908 2.909 0l13.085 13.085L29.09 0 32 2.908 18.908 16.005 31.993 29.09 29.09 32z"/></svg>
  </button>
</template>

<script>
import { back } from '@/mixins'

export default {
  name: 'ButtonClose',

  mixins: [ back ],

  mounted() {
    window.addEventListener('keyup', () => {
      if (event.keyCode === 27) {
        this.backUp()
      }
    })
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.backUp)
  },

  methods: {
    backUp() {
      if (this.$route.params.media_id) {
        this.$router.push(this.back)
      } else {
        this.$store.commit('overlay')
      }
    }
  }
}
</script>
